import { shouldShowOwfOpeningMonth } from "@faire/retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/utils";
import { smallBusinessGrantApplyRouteMatcher } from "@faire/retailer-visitor-shared/features/OpenWithFaire/routeUtilities";
import { SignUpRequestExpanded } from "@faire/retailer-visitor-shared/features/SignUp/SignUpRequestData";
import { IMatchedBusiness } from "@faire/web-api--source/indigofair/data/IMatchedBusiness";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { IRetailerLaunchWithFaire } from "@faire/web-api--source/indigofair/data/IRetailerLaunchWithFaire";
import { ISignUpRequest } from "@faire/web-api--source/indigofair/data/ISignUpRequest";

import BusinessPlatform = ISignUpRequest.BusinessPlatform;

/**
 * @returns whether the given creation time is OPENING_SOON
 */
export const isOpeningSoon = (
  creationTime: keyof typeof IRetailer.ReportedCreationTime | undefined
) => {
  return creationTime === "OPENING_SOON";
};

/**
 * @returns whether the given retailer is eligible for OwF
 */
export const isRetailerEligibleForOwF = (retailer: IRetailer | undefined) => {
  return (
    retailer?.launch_with_faire?.status ===
    IRetailerLaunchWithFaire.Status.ELIGIBLE
  );
};

/**
 * Given an array of business platforms, returns an object with the following properties:
 * - hasBrickAndMortar: true if the array contains brick and mortar
 * - hasOnline: true if the array contains online
 * - hasPopup: true if the array contains pop up
 * - isOnlineOnly: true if the array contains only online
 */
export const getBusinnessTypeDetails = (
  businessPlatforms: string[] | undefined
) => {
  const hasBrickAndMortar = businessPlatforms?.includes(
    BusinessPlatform.BRICK_AND_MORTAR
  );
  const hasOnline = businessPlatforms?.includes(BusinessPlatform.ONLINE_ONLY);
  const hasPopup = businessPlatforms?.includes(BusinessPlatform.POP_UP);
  const requirePostalCode = hasBrickAndMortar || hasPopup;

  return {
    hasBrickAndMortar,
    hasOnline,
    hasPopup,
    hasPhysicalStore: hasBrickAndMortar || hasPopup,
    requirePostalCode,
  };
};

/**
 * @returns whether has matched business (selected from the dropdown)
 */
export const hasMatchedBusiness = (
  matchedBusiness: IMatchedBusiness | undefined
): boolean => {
  return (
    !!matchedBusiness?.type &&
    matchedBusiness.type !== IMatchedBusiness.Type.MANUAL
  );
};

export const shouldShowOpeningMonthQuestion = (
  requestState: Partial<SignUpRequestExpanded> | undefined
) => {
  return shouldShowOwfOpeningMonth(requestState?.reported_creation_time);
};

/**
 * @returns whether the user has entered the sign up flow via the OwF Grant flow
 */
export const getIsOwFGrantFlow = (
  source: string | undefined,
  isOwFGrant: boolean
) => {
  return (
    !!smallBusinessGrantApplyRouteMatcher.match(source ?? "") && isOwFGrant
  );
};
